import React, { useContext } from "react";
import Button from "../button/Button";
import TranslateContext from "../../context/TranslateContext";
import SelectBox from "../selectBox/SelectBox";
import { languageList } from "../../utils/languageList";

import "./To.css";

const To = (props) => {
  const TranslateCtx = useContext(TranslateContext);

  const textToSpeech = () => {
    const synth = window.speechSynthesis;
    let text = TranslateCtx.transText;
    let speechLanguage = TranslateCtx.language;
    let yellThis = new SpeechSynthesisUtterance(text);
    yellThis.lang = speechLanguage;
    yellThis.rate = 0.7;
    synth.speak(yellThis);
  };
  return (
    <div>
      <div className="search-two-container">
        <h1>Translate To:</h1>
        <SelectBox />
        <input
          type="text"
          className="inputTo"
          value={TranslateCtx.transText}
          readOnly
        />
        <Button value="Text to Speech" onClick={textToSpeech} />
      </div>
    </div>
  );
};

export default To;
